import React, { useState, useEffect} from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


import axios from 'axios';
import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';


//pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

function PopupPDFViewer(props) {
    const isMobile = useMediaQuery('(max-width: 600px)');
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const [showviewer, setShowViewer] = useState(props.open)
    const [numPages, setNumPages] = useState(null);
    const [href, sethref] = useState(props.href)
    const [pdfurl,setPDFURL] = useState("")
    const auth = useSelector(state => state.auth)

    useEffect(()=> {
        async function getData() {
            // API To Get our Real URL.
            
            try {
                const token = auth.token;
                const url =`https://portal.ttpadvisory.co.uk:3556/api/ch/viewcompanyfilingitem`
                const response = await axios.post(url,
                    {url: props.url},
                    {
                        headers: {
                        Authorization: `Bearer ${token}`
                        }
                    }
                );
                if(response && (response.status??0) === 200 ){
                    console.log(response.data.data.url)
                    setPDFURL(response.data.data.url)
                }else
                    setPDFURL("")

            } catch (err) {
                setPDFURL("")
            }
        }
        if(showviewer !== props.open)
            setShowViewer(props.open)
        if(props.open) 
            getData();
        setShowViewer(props.open)
    },[props.open, props.url, props.time])
    
    const closeViewer = (e) => {
        setShowViewer(false)
        props.close(false)
    }

    const openProxiedPDF = async (signedUrl) => {
        const res = await fetch('https://portal.ttpadvisory.co.uk:3556/api/proxy-pdf', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ url: signedUrl }),
        });
      
        if (!res.ok) {
          console.log(`Failed to load PDF`)
          return;
        }
      
        const blob = await res.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
    };
    if(showviewer && (isIOS && pdfurl > "")) { 
        openProxiedPDF(pdfurl);
        props.close(false)
    }
    if(showviewer &&  pdfurl > ""  && !isIOS ) // && !isIOS 
    return (
      <Dialog open={showviewer} onClose={closeViewer} fullWidth maxWidth="lg" >
        <DialogTitle>
          PDF Viewer
          <IconButton
            aria-label="close"
            onClick={closeViewer}
            sx={{ position: 'absolute', right: 4, top: 4, height: '90%' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            <iframe
            src={pdfurl}
            title="PDF Preview"
            style={{ width: '99vw', height: '100vh', border: 'none'}}
            />
        </DialogContent>
      </Dialog>
    );
}


export default PopupPDFViewer